import script from "./ApplyTdsVdsHeadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyTdsVdsHeadModal.vue?vue&type=script&setup=true&lang=js"

import "./ApplyTdsVdsHeadModal.vue?vue&type=style&index=0&id=12d9546e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d9546e"]])

export default __exports__